import { Card, Space } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import SecondaryProgramCoursesDataTable from '../../../components/datatables/secondary/SecondaryProgramCoursesDataTable';
import Breadcrumbs from '../../../config/Breadcrumbs';
import InstitutionDTO from '../../../models/InstitutionDTO';
import UserSecurity from '../../../models/UserSecurity';
import HeaderPortal from '../../../portals/HeaderPortal';
import { StateStoreModel } from '../../../redux/state/StateStoreModel';
import HistoryUtil from '../../../utils/HistoryUtil';
import ParameterUtil from '../../../utils/ParameterUtil';

interface AcademicYearSecondaryProgramCoursesConfigurationPageState {
  loading: boolean;
  academicYear: number;
}

interface AcademicYearSecondaryProgramCoursesConfigurationPageProps {
  currentUser: UserSecurity | null;
  selectedInstitution: InstitutionDTO | null;
}

class AcademicYearSecondaryProgramCoursesConfigurationPage extends React.Component<AcademicYearSecondaryProgramCoursesConfigurationPageProps & RouteComponentProps<RouteObject>, AcademicYearSecondaryProgramCoursesConfigurationPageState> {

  constructor(props: AcademicYearSecondaryProgramCoursesConfigurationPageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      loading: false,
      academicYear: 0,
    };
  }

  componentDidMount() {
    const id = Number.parseInt(ParameterUtil.getPathPart(this.props.match, 'academicYearId'));

    this.setState({ academicYear: id });
  }

  private onBack = () => {
    HistoryUtil.goBack();
  }

  render() {
    return (
      <Content >
        <HeaderPortal title='Program Courses' breadcrumbs={Breadcrumbs.academicYearSecondaryProgramCoursesConfigurationList(this.state.academicYear)}
          onBack={this.onBack} />
        < Space direction="vertical" size="large">
          <Card title="Program Courses">
            <Space direction='vertical' size="large">
              <SecondaryProgramCoursesDataTable
                academicYear={this.state.academicYear} />
            </Space>
          </Card>
        </Space>
      </Content>
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
    selectedInstitution: state.Institution.Selected
  };
}

export default withRouter(connect(mapStateToProps)(AcademicYearSecondaryProgramCoursesConfigurationPage));
